export default __webpack_public_path__ + "static/media/LessThanIcon.d7c38b83.svg";